
import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config.json";

import {
    Box,
    Grid,
    Typography,
    Card,
    CardContent,
    Container,
    Button,
} from "@mui/material";

const Home = () => {
    const [serverStats, setServerStats] = useState({
        serverOnline: false,
        onlinePlayers: 0,
    });

    useEffect(() => {
        const fetchOnlineStatus = async () => {
            try {
                const { data } = await axios.get(
                    config.apiEndPoint + "statistics"
                );

                const stats = data?.data || data || {};

                setServerStats({
                    serverOnline: !!stats.serverOnline,
                    onlinePlayers: stats.onlinePlayers ?? 0,
                });
            } catch (e) { }
        };

        fetchOnlineStatus();
    }, []);

    return (
        <Box
            sx={{
                background: "#070707",
                color: "#fff",
                minHeight: "100vh",
                overflow: "hidden",
                fontFamily: "inherit",
            }}
        >

            {/* ========================================================= */}
            {/* HERO */}
            {/* ========================================================= */}

            <Box
                sx={{
                    minHeight: "100vh",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",

                    background: `
radial - gradient(
    circle at 50 % 15 %,
    rgba(255, 70, 15, 0.20),
    transparent 32 %
                        ),
    radial - gradient(
        circle at 15 % 80 %,
        rgba(180, 35, 10, 0.14),
        transparent 35 %
                        ),
    radial - gradient(
        circle at 85 % 70 %,
        rgba(255, 110, 20, 0.10),
        transparent 35 %
                        ),
    linear - gradient(
        180deg,
                            #050505 0 %,
                            #120806 48 %,
                            #070606 100 %
                        )
        `,
                }}
            >

                {/* ===================================================== */}
                {/* FIRE GLOW */}
                {/* ===================================================== */}

                <Box
                    sx={{
                        position: "absolute",
                        top: "-260px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: 750,
                        height: 750,
                        borderRadius: "50%",
                        background: "rgba(255,65,10,.10)",
                        filter: "blur(150px)",
                        pointerEvents: "none",
                    }}
                />

                {/* ===================================================== */}
                {/* LOWER FIRE GLOW */}
                {/* ===================================================== */}

                <Box
                    sx={{
                        position: "absolute",
                        bottom: "-280px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: 900,
                        height: 550,
                        borderRadius: "50%",
                        background: "rgba(180,35,8,.12)",
                        filter: "blur(150px)",
                        pointerEvents: "none",
                    }}
                />

                {/* ===================================================== */}
                {/* SIDE GLOW */}
                {/* ===================================================== */}

                <Box
                    sx={{
                        position: "absolute",
                        left: "-250px",
                        top: "35%",
                        width: 500,
                        height: 500,
                        borderRadius: "50%",
                        background: "rgba(255,80,10,.07)",
                        filter: "blur(130px)",
                        pointerEvents: "none",
                    }}
                />

                <Box
                    sx={{
                        position: "absolute",
                        right: "-250px",
                        top: "45%",
                        width: 500,
                        height: 500,
                        borderRadius: "50%",
                        background: "rgba(255,110,20,.06)",
                        filter: "blur(130px)",
                        pointerEvents: "none",
                    }}
                />

                {/* ===================================================== */}
                {/* TOP FIRE LINE */}
                {/* ===================================================== */}

                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: 3,
                        background:
                            "linear-gradient(90deg,transparent,#8b1e0d,#ff4b16,#ff9a3d,#ff4b16,#8b1e0d,transparent)",
                        boxShadow: "0 0 25px rgba(255,70,15,.75)",
                    }}
                />

                <Container
                    maxWidth="lg"
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        py: { xs: 8, md: 10 },
                    }}
                >

                    {/* ================================================= */}
                    {/* CENTER LOGO */}
                    {/* ================================================= */}

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            mb: { xs: 3, md: 1 },
                        }}
                    >
                        <Box
                            component="img"
                            src="https://vexconquer.site/files1/bg2.png"
                            alt="Vex Conquer"
                            sx={{
                                width: {
                                    xs: "90%",
                                    sm: 550,
                                    md: 700,
                                },
                                maxWidth: "100%",
                                height: "auto",

                                filter:
                                    "drop-shadow(0 0 25px rgba(255,70,15,.28)) drop-shadow(0 25px 45px rgba(0,0,0,.9))",

                                transition: "all .4s ease",

                                "&:hover": {
                                    transform: "scale(1.02)",
                                    filter:
                                        "drop-shadow(0 0 40px rgba(255,75,15,.55)) drop-shadow(0 25px 45px rgba(0,0,0,.9))",
                                },
                            }}
                        />
                    </Box>

                    {/* ================================================= */}
                    {/* SERVER LABEL */}
                    {/* ================================================= */}

                    <Box
                        sx={{
                            textAlign: "center",
                            mb: 3,
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#ff7135",
                                fontSize: {
                                    xs: 11,
                                    md: 14,
                                },
                                fontWeight: 900,
                                letterSpacing: {
                                    xs: 3,
                                    md: 6,
                                },
                                textTransform: "uppercase",
                            }}
                        >
                            VEX CONQUER • CLASSIC 5165
                        </Typography>

                        <Typography
                            sx={{
                                color: "#777",
                                fontSize: 12,
                                letterSpacing: 3,
                                mt: 1,
                            }}
                        >
                            LEVEL 130 • 1ST REBORN • THE CLASSIC RETURNS
                        </Typography>
                    </Box>

                    {/* ================================================= */}
                    {/* HERO TITLE */}
                    {/* ================================================= */}

                    <Box
                        sx={{
                            textAlign: "center",
                            maxWidth: 900,
                            mx: "auto",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: {
                                    xs: 36,
                                    sm: 50,
                                    md: 70,
                                },
                                fontWeight: 900,
                                lineHeight: 1.02,
                                letterSpacing: {
                                    xs: -1,
                                    md: -3,
                                },

                                background:
                                    "linear-gradient(180deg,#fff1e5 0%,#ff7135 42%,#b3260b 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",

                                textShadow:
                                    "0 5px 30px rgba(255,70,15,.18)",
                            }}
                        >
                            THE BATTLE
                            <br />
                            STARTS HERE
                        </Typography>

                        <Typography
                            sx={{
                                color: "#aaa",
                                mt: 3,
                                mx: "auto",
                                maxWidth: 700,
                                fontSize: {
                                    xs: 15,
                                    md: 18,
                                },
                                lineHeight: 1.8,
                            }}
                        >
                            Step into Vex Conquer 5165 — a classic world built
                            around real competition, old-school progression,
                            brutal guild wars, dangerous bosses, and the
                            freedom to build your character your way.
                        </Typography>
                    </Box>

                    {/* ================================================= */}
                    {/* BUTTONS */}
                    {/* ================================================= */}

                    <Box
                        sx={{
                            mt: 5,
                            display: "flex",
                            justifyContent: "center",
                            gap: 2,
                            flexWrap: "wrap",
                        }}
                    >

                        <Button
                            onClick={() =>
                                window.location.href =
                                "https://vexconquer.site/user/register"
                            }
                            sx={{
                                px: {
                                    xs: 4,
                                    md: 6,
                                },
                                py: 1.8,

                                background:
                                    "linear-gradient(135deg,#9f210b 0%,#ff5420 45%,#ff9a3d 100%)",

                                color: "#fff",
                                fontWeight: 900,
                                letterSpacing: 1,
                                borderRadius: 1,

                                boxShadow:
                                    "0 8px 35px rgba(255,70,15,.25)",

                                transition: ".3s",

                                "&:hover": {
                                    background:
                                        "linear-gradient(135deg,#c52d0d,#ff7135,#ffb05b)",
                                    transform: "translateY(-3px)",
                                    boxShadow:
                                        "0 14px 40px rgba(255,70,15,.45)",
                                },
                            }}
                        >
                            ⚔ CREATE YOUR WARRIOR
                        </Button>

                        <Button
                            onClick={() =>
                                window.location.href =
                                "https://vexconquer.site/downloads"
                            }
                            sx={{
                                px: {
                                    xs: 4,
                                    md: 6,
                                },
                                py: 1.8,

                                color: "#ff7135",
                                fontWeight: 900,
                                letterSpacing: 1,

                                border:
                                    "1px solid rgba(255,90,35,.65)",

                                borderRadius: 1,

                                background:
                                    "rgba(255,70,15,.03)",

                                transition: ".3s",

                                "&:hover": {
                                    background:
                                        "rgba(255,70,15,.10)",
                                    borderColor: "#ff8a50",
                                    transform: "translateY(-3px)",
                                },
                            }}
                        >
                            ↓ DOWNLOAD VEX
                        </Button>

                    </Box>

                    {/* ================================================= */}
                    {/* SERVER STATUS */}
                    {/* ================================================= */}

                    <Card
                        sx={{
                            maxWidth: 850,
                            mx: "auto",
                            mt: 6,

                            background:
                                "linear-gradient(135deg,rgba(24,12,9,.96),rgba(10,8,7,.96))",

                            border:
                                "1px solid rgba(255,75,25,.25)",

                            borderRadius: 2,

                            boxShadow:
                                "0 25px 70px rgba(0,0,0,.65)",

                            position: "relative",
                            overflow: "hidden",

                            "&:before": {
                                content: '""',
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: 2,
                                background:
                                    "linear-gradient(90deg,transparent,#a8270d,#ff5b25,#ff9a4d,#ff5b25,#a8270d,transparent)",
                            },
                        }}
                    >

                        <CardContent
                            sx={{
                                p: {
                                    xs: 3,
                                    md: 4,
                                },
                            }}
                        >

                            <Grid
                                container
                                spacing={3}
                                alignItems="center"
                            >

                                {/* PLAYERS */}

                                <Grid item xs={6} md={4}>
                                    <Typography
                                        sx={{
                                            color: "#a64b32",
                                            fontSize: 11,
                                            fontWeight: 800,
                                            letterSpacing: 2,
                                        }}
                                    >
                                        WARRIORS ONLINE
                                    </Typography>

                                    <Typography
                                        sx={{
                                            mt: .5,
                                            fontSize: {
                                                xs: 30,
                                                md: 38,
                                            },
                                            fontWeight: 900,
                                            color: "#ff8750",
                                        }}
                                    >
                                        {serverStats.onlinePlayers}
                                    </Typography>
                                </Grid>

                                {/* STATUS */}

                                <Grid item xs={6} md={4}>
                                    <Typography
                                        sx={{
                                            color: "#a64b32",
                                            fontSize: 11,
                                            fontWeight: 800,
                                            letterSpacing: 2,
                                        }}
                                    >
                                        BATTLE STATUS
                                    </Typography>

                                    <Typography
                                        sx={{
                                            mt: .5,
                                            fontSize: {
                                                xs: 22,
                                                md: 28,
                                            },
                                            fontWeight: 900,
                                            color:
                                                serverStats.serverOnline
                                                    ? "#58d27b"
                                                    : "#e05a5a",
                                        }}
                                    >
                                        {serverStats.serverOnline
                                            ? "● ONLINE"
                                            : "● OFFLINE"}
                                    </Typography>
                                </Grid>

                                {/* VERSION */}

                                <Grid item xs={12} md={4}>
                                    <Typography
                                        sx={{
                                            color: "#a64b32",
                                            fontSize: 11,
                                            fontWeight: 800,
                                            letterSpacing: 2,
                                        }}
                                    >
                                        SERVER BUILD
                                    </Typography>

                                    <Typography
                                        sx={{
                                            mt: .5,
                                            fontSize: 22,
                                            fontWeight: 900,
                                            color: "#ddd",
                                        }}
                                    >
                                        5165 CLASSIC
                                    </Typography>
                                </Grid>

                            </Grid>

                            {/* STATUS BAR */}

                            <Box
                                sx={{
                                    mt: 3,
                                    height: 3,
                                    borderRadius: 10,
                                    background:
                                        "rgba(255,255,255,.06)",
                                    overflow: "hidden",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        background:
                                            "linear-gradient(90deg,#731808,#c7350e,#ff5420,#ff9a4d,#ff5420,#c7350e,#731808)",
                                    }}
                                />
                            </Box>

                            <Typography
                                sx={{
                                    mt: 2,
                                    color: "#777",
                                    textAlign: "center",
                                    fontSize: 12,
                                }}
                            >
                                Classic 5165 gameplay • Level 130 •
                                Built for warriors who want real competition
                            </Typography>

                        </CardContent>
                    </Card>

                </Container>
            </Box>


            {/* ========================================================= */}
            {/* VEX FEATURES */}
            {/* ========================================================= */}

            <Box
                sx={{
                    position: "relative",
                    py: {
                        xs: 9,
                        md: 13,
                    },

                    background:
                        "linear-gradient(180deg,#070606 0%,#120907 50%,#070606 100%)",

                    borderTop:
                        "1px solid rgba(255,70,15,.12)",
                }}
            >

                {/* BACKGROUND FIRE GLOW */}

                <Box
                    sx={{
                        position: "absolute",
                        top: -200,
                        left: -200,
                        width: 500,
                        height: 500,
                        borderRadius: "50%",
                        background:
                            "rgba(255,60,10,.07)",
                        filter: "blur(130px)",
                    }}
                />

                <Box
                    sx={{
                        position: "absolute",
                        bottom: -200,
                        right: -200,
                        width: 500,
                        height: 500,
                        borderRadius: "50%",
                        background:
                            "rgba(190,35,8,.08)",
                        filter: "blur(130px)",
                    }}
                />

                <Container
                    maxWidth="lg"
                    sx={{
                        position: "relative",
                        zIndex: 2,
                    }}
                >

                    {/* SECTION TITLE */}

                    <Box
                        sx={{
                            textAlign: "center",
                            mb: 8,
                        }}
                    >

                        <Typography
                            sx={{
                                color: "#b04a2c",
                                fontSize: 12,
                                fontWeight: 900,
                                letterSpacing: 4,
                                mb: 2,
                            }}
                        >
                            WELCOME TO VEX
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: {
                                    xs: 36,
                                    md: 58,
                                },
                                fontWeight: 900,
                                lineHeight: 1.1,
                            }}
                        >
                            OLD SCHOOL.
                            <span
                                style={{
                                    color: "#ff5b25",
                                }}
                            >
                                {" "}REAL BATTLES.
                            </span>
                        </Typography>

                        <Typography
                            sx={{
                                color: "#777",
                                maxWidth: 680,
                                mx: "auto",
                                mt: 3,
                                lineHeight: 1.8,
                            }}
                        >
                            Vex keeps the heart of 5165 alive while giving
                            warriors everything they need to compete,
                            progress, trade, fight and conquer.
                        </Typography>

                    </Box>


                    <Grid
                        container
                        spacing={4}
                    >

                        {/* ================================================= */}
                        {/* SERVER INFORMATION */}
                        {/* ================================================= */}

                        <Grid item xs={12} md={6}>

                            <Card
                                sx={{
                                    height: "100%",
                                    background:
                                        "linear-gradient(145deg,#17100d,#0c0908)",

                                    border:
                                        "1px solid rgba(255,75,25,.22)",

                                    borderRadius: 2,

                                    boxShadow:
                                        "0 25px 65px rgba(0,0,0,.5)",

                                    position: "relative",
                                    overflow: "hidden",

                                    "&:before": {
                                        content: '""',
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: 2,
                                        background:
                                            "linear-gradient(90deg,transparent,#ff5420,transparent)",
                                    },
                                }}
                            >

                                <CardContent
                                    sx={{
                                        p: {
                                            xs: 4,
                                            md: 5,
                                        },
                                    }}
                                >

                                    <Typography
                                        sx={{
                                            color: "#ff6130",
                                            fontWeight: 900,
                                            fontSize: 12,
                                            letterSpacing: 3,
                                            mb: 3,
                                        }}
                                    >
                                        VEX SERVER RULESET
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: {
                                                xs: 34,
                                                md: 46,
                                            },
                                            fontWeight: 900,
                                            lineHeight: 1.1,
                                            mb: 3,
                                        }}
                                    >
                                        Simple Rules.
                                        <br />
                                        Hard Battles.
                                        <br />
                                        <span
                                            style={{
                                                color: "#ff5b25",
                                            }}
                                        >
                                            No Confusion.
                                        </span>
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color: "#999",
                                            lineHeight: 1.9,
                                            mb: 4,
                                        }}
                                    >
                                        Vex Conquer stays focused on the
                                        classic 5165 formula. Build your
                                        character, improve your gear, earn
                                        your CPs and prove yourself on the
                                        battlefield.
                                    </Typography>


                                    <Grid
                                        container
                                        spacing={1.5}
                                    >

                                        {[
                                            "Level 130",
                                            "Max +9",
                                            "Bless -5",
                                            "1st Reborn",
                                            "4 Classic Classes",
                                            "No Ninja",
                                            "No Monk",
                                            "CPS System",
                                        ].map((feature) => (

                                            <Grid
                                                item
                                                xs={6}
                                                key={feature}
                                            >

                                                <Box
                                                    sx={{
                                                        p: 1.8,

                                                        background:
                                                            "linear-gradient(135deg,rgba(255,70,15,.09),rgba(255,70,15,.025))",

                                                        border:
                                                            "1px solid rgba(255,75,25,.14)",

                                                        borderRadius: 1,

                                                        textAlign: "center",

                                                        transition: ".3s",

                                                        "&:hover": {
                                                            borderColor:
                                                                "#ff5b25",

                                                            background:
                                                                "rgba(255,70,15,.12)",

                                                            transform:
                                                                "translateY(-3px)",
                                                        },
                                                    }}
                                                >

                                                    <Typography
                                                        sx={{
                                                            fontSize: 13,
                                                            fontWeight: 700,
                                                            color: "#ddd",
                                                        }}
                                                    >
                                                        {feature}
                                                    </Typography>

                                                </Box>

                                            </Grid>

                                        ))}

                                    </Grid>

                                </CardContent>

                            </Card>

                        </Grid>


                        {/* ================================================= */}
                        {/* VEX EXPERIENCE */}
                        {/* ================================================= */}

                        <Grid item xs={12} md={6}>

                            <Card
                                sx={{
                                    height: "100%",

                                    background:
                                        "linear-gradient(145deg,#17100d,#0c0908)",

                                    border:
                                        "1px solid rgba(255,75,25,.22)",

                                    borderRadius: 2,

                                    boxShadow:
                                        "0 25px 65px rgba(0,0,0,.5)",

                                    position: "relative",
                                    overflow: "hidden",

                                    "&:before": {
                                        content: '""',
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: 2,
                                        background:
                                            "linear-gradient(90deg,transparent,#ff5420,transparent)",
                                    },
                                }}
                            >

                                <CardContent
                                    sx={{
                                        p: {
                                            xs: 4,
                                            md: 5,
                                        },
                                    }}
                                >

                                    <Typography
                                        sx={{
                                            color: "#ff6130",
                                            fontWeight: 900,
                                            fontSize: 12,
                                            letterSpacing: 3,
                                            mb: 3,
                                        }}
                                    >
                                        WHAT AWAITS YOU
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: {
                                                xs: 34,
                                                md: 46,
                                            },
                                            fontWeight: 900,
                                            lineHeight: 1.15,
                                            mb: 4,
                                        }}
                                    >
                                        Enter the World.
                                        <br />
                                        <span
                                            style={{
                                                color: "#ff5b25",
                                            }}
                                        >
                                            Make It Yours.
                                        </span>
                                    </Typography>


                                    <Grid
                                        container
                                        spacing={1.5}
                                    >

                                        {[
                                            "Blue Mouse Quest",
                                            "Terato Dragon",
                                            "Mets Zone",
                                            "DB Devil Boss",
                                            "Clean Water Lord",
                                            "CPS Shopping Mall",
                                            "Guild Wars",
                                            "Classic PvP",
                                        ].map((feature) => (

                                            <Grid
                                                item
                                                xs={6}
                                                key={feature}
                                            >

                                                <Box
                                                    sx={{
                                                        p: 1.8,

                                                        background:
                                                            "linear-gradient(135deg,rgba(255,70,15,.09),rgba(255,70,15,.025))",

                                                        border:
                                                            "1px solid rgba(255,75,25,.14)",

                                                        borderRadius: 1,

                                                        textAlign: "center",

                                                        transition: ".3s",

                                                        "&:hover": {
                                                            borderColor:
                                                                "#ff5b25",

                                                            background:
                                                                "rgba(255,70,15,.10)",

                                                            transform:
                                                                "translateY(-3px)",
                                                        },
                                                    }}
                                                >

                                                    <Typography
                                                        sx={{
                                                            fontSize: 13,
                                                            fontWeight: 700,
                                                            color: "#ddd",
                                                        }}
                                                    >
                                                        {feature}
                                                    </Typography>

                                                </Box>

                                            </Grid>

                                        ))}

                                    </Grid>


                                    {/* DESCRIPTION BOX */}

                                    <Box
                                        sx={{
                                            mt: 4,
                                            p: 3,

                                            borderRadius: 1,

                                            background:
                                                "rgba(255,70,15,.045)",

                                            border:
                                                "1px solid rgba(255,75,25,.12)",
                                        }}
                                    >

                                        <Typography
                                            sx={{
                                                color: "#999",
                                                lineHeight: 1.9,
                                                fontSize: 14,
                                            }}
                                        >
                                            Vex Conquer is built for players
                                            who miss the feeling of classic
                                            Conquer — when your gear mattered,
                                            your guild had your back, and every
                                            battle could change your name.
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#ff6735",
                                                mt: 2,
                                                fontWeight: 800,
                                                fontSize: 13,
                                            }}
                                        >
                                            PVP • GUILD WARS • BOSSES • CPS
                                        </Typography>

                                    </Box>

                                </CardContent>

                            </Card>

                        </Grid>

                    </Grid>

                </Container>
            </Box>


            {/* ========================================================= */}
            {/* BOTTOM CTA */}
            {/* ========================================================= */}

            <Box
                sx={{
                    py: {
                        xs: 9,
                        md: 12,
                    },

                    textAlign: "center",

                    background:
                        "radial-gradient(circle at center,rgba(255,65,15,.13),transparent 55%),#070606",

                    borderTop:
                        "1px solid rgba(255,70,15,.12)",
                }}
            >

                <Container maxWidth="md">

                    <Typography
                        sx={{
                            color: "#b04a2c",
                            fontSize: 12,
                            fontWeight: 900,
                            letterSpacing: 4,
                            mb: 2,
                        }}
                    >
                        YOUR NAME. YOUR GUILD. YOUR LEGACY.
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: {
                                xs: 36,
                                md: 58,
                            },
                            fontWeight: 900,
                            lineHeight: 1.1,
                        }}
                    >
                        ARE YOU READY
                        <br />
                        <span
                            style={{
                                color: "#ff5b25",
                            }}
                        >
                            TO CONQUER?
                        </span>
                    </Typography>

                    <Typography
                        sx={{
                            color: "#777",
                            mt: 3,
                            mb: 4,
                        }}
                    >
                        Create your character. Find your allies.
                        <br />
                        Enter the battlefield and write your own story.
                    </Typography>

                    <Button
                        onClick={() =>
                            window.location.href =
                            "https://vexconquer.site/user/register"
                        }
                        sx={{
                            px: 6,
                            py: 1.8,

                            background:
                                "linear-gradient(135deg,#9f210b,#ff5420,#ff9a3d)",

                            color: "#fff",
                            fontWeight: 900,
                            letterSpacing: 1,

                            borderRadius: 1,

                            boxShadow:
                                "0 10px 40px rgba(255,70,15,.25)",

                            "&:hover": {
                                background:
                                    "linear-gradient(135deg,#c52d0d,#ff7135,#ffb05b)",
                                transform: "translateY(-3px)",
                            },
                        }}
                    >
                        JOIN VEX CONQUER
                    </Button>

                </Container>

            </Box>

        </Box>
    );
};

export default Home;
